module.exports = __webpack_public_path__ + "media/images/gallery/constellations/figure_layer_on-cc8cb71ac3817f6a1f618bdabf64c441.jpg";